var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},_vm._l((_vm.media),function(item,index){return _c('div',{key:index},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_c('icon',{attrs:{"description":item.icon,"size":"28"}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }